export default "__VITE_ASSET__LuDkIdVy__"